module.exports = __webpack_public_path__ + "img/u6395.18422cd9.png";